import { colors, getBorderRadius, getSpacing } from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import { CheckboxProps } from './checkbox';

export const StyledCheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${getSpacing('xxs')};
  user-select: none;
`;

export const CheckboxContainer = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  gap: ${getSpacing('xs')};
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
`;

export const HiddenCheckbox = styled.input<CheckboxProps>`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;

  &:focus + div {
    box-shadow: 0 0 0 ${(p) => (p.checked ? '2px' : '1px')} ${colors.black};
    border: ${(p) => p.checked && `1px solid ${colors.white}`};
  }

  &:disabled + div {
    background: ${(p) => (p.checked ? colors.gray2 : colors.white)};
    border: 2px solid ${colors.gray2};
    cursor: not-allowed;
  }
`;

export const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: flex;
  width: 20px;
  height: 20px;
  background: ${(props) => (props.checked ? colors.black : colors.white)};
  border-radius: ${getBorderRadius('xs')};
  border: 2px solid ${colors.black};

  svg {
    position: absolute;
    top: 0px;
    left: 0px;
  }
`;

export const CheckboxLabelWrap = styled.label`
  position: relative;
  cursor: pointer;
`;

export const CheckboxText = styled.div`
  cursor: pointer;
`;
